import { CircularProgress } from "@mui/material";
import "./loader.component.scss";

const LoaderComponent = () => {
    return <div className="loader-container">
        <CircularProgress color="secondary" />
    </div>
}

export default LoaderComponent;